import { render, staticRenderFns } from "./yConfirm.vue?vue&type=template&id=29f880f7"
import script from "./yConfirm.vue?vue&type=script&lang=js"
export * from "./yConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports